import Cookies from 'js-cookie';
import { fetchQuery, graphql } from 'react-relay';
import { Environment, Store, RecordSource, Network, FetchFunction } from 'relay-runtime';

function getTemplateRecommendationsSearchResultsQueryVars(location: Location) {
	let anonymousId = '';
	try {
		anonymousId = JSON.parse(decodeURIComponent(Cookies.get('ajs_anonymous_id') || `""`));
	} catch (error) {
		console.log(`Error parsing anonymousId ${error}`);
		anonymousId = Cookies.get('ajs_anonymous_id') || '';
	}
	return {
		// NOTE: There is a hardcoded exemption in GRS to return nothing when
		// the first 9 recommendations match a default set. This appears to have
		// been a specific ask, but is nonetheless very unexpected.
		// See: https://atlassian.slack.com/archives/C053051JN9Y/p1729642717332069?thread_ts=1729620526.565589&cid=C053051JN9Y
		first: 9,
		context: {
			useCase: 'wacConfluenceTemplates',
			product: 'marketing',
			anonymousId,
			userId: Cookies.get('__aid_user_id') || '',
			custom: {
				paidSearchTerm: new URLSearchParams(location.search).get('keyword'),
			},
		},
	};
}

const TemplateRecommendationsSearchResultsRelayQuery = graphql`
	query useSearchRecommendationsQuery($context: GrowthRecContext!, $first: Int) {
		growthRecommendations {
			recommendations(first: $first, context: $context) {
				... on GrowthRecRecommendations {
					data {
						entityId
					}
				}
			}
		}
	}
`;

export const useSearchRecommendations = async () => {
	const GATEWAY_URL =
		process.env['NODE_ENV'] != 'production'
			? 'https://wac.stg.internal.atlassian.com/gateway/api/graphql'
			: 'https://www.atlassian.com/gateway/api/graphql';

	const fetchGraphQL: FetchFunction = async (request, variables) => {
		const resp = await fetch(GATEWAY_URL, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ query: request.text, variables }),
		});
		if (!resp.ok) {
			throw new Error('Response failed.');
		}
		return await resp.json();
	};

	const environment = new Environment({
		store: new Store(new RecordSource({})),
		network: Network.create(fetchGraphQL),
	});

	const recommendationData = await fetchQuery(
		environment,
		TemplateRecommendationsSearchResultsRelayQuery,
		getTemplateRecommendationsSearchResultsQueryVars(window.location),
	)
		.toPromise()
		.then((data) => data)
		.catch((error) => {
			console.log(error);
		});

	return recommendationData;
};
